import { EventProps, PageEvents, WebPageEvents } from '@griply/types';
import { useEffect } from 'react';

import { useTrackEvents } from './use-track-events';

export const useTrackPageVisitEvent = <
  TrackEvent extends PageEvents | WebPageEvents,
>(
  event: TrackEvent,
  eventProps: EventProps<TrackEvent>,
) => {
  const track = useTrackEvents();

  useEffect(() => {
    track(event, eventProps);
  }, [event, eventProps, track]);
};
